(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/page.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.ticketsOrderHome.utils.logger;
const useOrderHomeContext = svs.ticketsOrderHome.context.useOrderHomeContext;
const orderTickets = svs.ticketsOrderHome.services.orderTickets;
const useCustomerPreferences = svs.ticketsOrderHome.hooks.useCustomerPreferences;
const appendTicketThemeToOrderItems = svs.ticketsOrderHome.utils.appendTicketThemeToOrderItems;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.orderHome.components,
  CartBottomSheetDynamicAction = _svs$ticketsOrderHome.CartBottomSheetDynamicAction,
  CustomerAddressInformationComponent = _svs$ticketsOrderHome.CustomerAddressInformationComponent;
const SearchReceiver = svs.ticketsOrderHome.orderHome.receiver.components.SearchReceiver;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.tracking,
  trackOrderHomeOrderTransaction = _svs$ticketgames$tick.trackOrderHomeOrderTransaction,
  trackOrderHomeReceiver = _svs$ticketgames$tick.trackOrderHomeReceiver;
const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.routes.ORDER_HOME,
  CONFIRMATION = _svs$ticketsOrderHome2.CONFIRMATION,
  MESSAGE = _svs$ticketsOrderHome2.MESSAGE;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const getHasAfterPayParam = svs.ticketsOrderHome.utils.getHasAfterPayParam;
const headerTitle = svs.ticketsOrderHome.data.config.orderHome.orderHomeReceiver.headerTitle;
setGlobal('svs.ticketsOrderHome.pages.Receiver', _ref => {
  var _receiver$details;
  let history = _ref.history;
  const _useOrderHomeContext = useOrderHomeContext(),
    _useOrderHomeContext$ = _useOrderHomeContext.state,
    cart = _useOrderHomeContext$.cart,
    receiver = _useOrderHomeContext$.receiver,
    setOrder = _useOrderHomeContext.setOrder,
    setReceiver = _useOrderHomeContext.setReceiver;
  const _useCustomerPreferenc = useCustomerPreferences(),
    data = _useCustomerPreferenc.data,
    error = _useCustomerPreferenc.error,
    loading = _useCustomerPreferenc.loading;
  const afterPayRef = React.useRef(getHasAfterPayParam());
  const onChangeOtherReceiver = value => {
    const other = value === 'other';
    setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
      other
    }));
    trackOrderHomeReceiver(other);
  };
  const handleContinue = () => {
    var _receiver$results$len, _receiver$results;
    logger.info("Continuing with chosen receiver after ".concat((_receiver$results$len = (_receiver$results = receiver.results) === null || _receiver$results === void 0 ? void 0 : _receiver$results.length) !== null && _receiver$results$len !== void 0 ? _receiver$results$len : 0, " searches"));
    history.push(MESSAGE);
  };
  const handlePay = () => {
    orderTickets({
      tickets: cart.tickets,
      afterPay: afterPayRef.current,
      onCancel: () => {},
      onDone: _ref2 => {
        let response = _ref2.response;
        const orderItems = (response === null || response === void 0 ? void 0 : response.orderItems) || [];
        const referenceId = response === null || response === void 0 ? void 0 : response.referenceId;
        if (orderItems.length) {
          const order = {
            orderItems,
            referenceId
          };
          const trackingItems = appendTicketThemeToOrderItems(orderItems).map(item => _objectSpread(_objectSpread({}, item), {}, {
            ticketOrder: receiver.other ? 'send_to_other' : 'send_to_me'
          }));
          trackOrderHomeOrderTransaction(referenceId, trackingItems, svs.ticketsOrderHome.utils.constants.SHIPPING_COST);
          setOrder(order);
          history.push(CONFIRMATION.replace(':referenceId', referenceId));
        }
      }
    });
  };
  React.useEffect(() => {
    if (afterPayRef.current) {
      handlePay();
    }
  }, []);
  return React.createElement("div", {
    className: "order-home-receiver-page"
  }, React.createElement("div", {
    className: "f-body u-text-center w100 order-home-max-width"
  }, React.createElement("h2", {
    className: "h2"
  }, headerTitle), React.createElement(RadioGroup, {
    size: 200,
    thin: true
  }, React.createElement(RadioButton, {
    checked: !receiver.other,
    name: "mottagare",
    onChange: onChangeOtherReceiver,
    value: "self"
  }, "Hem till mig"), React.createElement(RadioButton, {
    checked: receiver.other,
    name: "mottagare",
    onChange: onChangeOtherReceiver,
    value: "other"
  }, "Till n\xE5gon annan"))), receiver.other ? React.createElement(SearchReceiver, null) : React.createElement("div", {
    className: "order-home-receiver-body margin-top-3 f-body"
  }, React.createElement("h4", {
    className: "h4 fw-500"
  }, "Mottagare"), React.createElement(CustomerAddressInformationComponent, {
    className: "padding-bottom-2 border-bottom",
    data: data,
    error: error,
    loading: loading
  }), React.createElement("p", {
    className: "f-content fw-500 u-text-center w100 padding-top-1 margin-0"
  }, "Lotterna skickas direkt efter betalning och \xE4r framme inom n\xE5gra dagar.")), React.createElement(CartBottomSheetDynamicAction, {
    disabled: receiver.other && !((_receiver$details = receiver.details) !== null && _receiver$details !== void 0 && _receiver$details.id),
    onContinue: handleContinue,
    onPay: handlePay,
    readyToPay: !receiver.other
  }));
});

 })(window);